<template>
	<div class="mapClass_ul">
		<img :src="mapUrl" class="mapImg" @load="imgSuccess">
		<div id="mapBack" style="position: absolute;width: 100%;height: 100%;">
			<div v-for="(objl, index) in lineList" :key="'lines' + index" class="linesClass"
				:style="{borderTop: `6px solid ${objl.lineColor}`,left: objl.left + 'px', top: objl.top + 'px', width: objl.width + 'px','transform-origin': `0 0`,'-webkit-transform': `rotate(${objl.rotate}deg)`}">
			</div>
		</div>
		<div id="aaa" ref="circle_id" class="mapPostion" v-show="ifDraw">
			<div ref="circle_bottom" class="circle_bottom animation"></div>
		</div>
	</div>
</template>

<script>
	import {
		positonInfo,
		robotRouteByRobotId,
		getMapAndRouteByNumber
	} from '@/api/user'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				dialogClose: require('../../static/img/close.png'),
				robotSrc: require('../../static/img/xyRobot.png'),
				mapUrl: '',
				robotId: '',
				lineList: [],
				ifDraw: false,
				mFloorEntity: {}
			}
		},
		props: {
			position: {},
			posInfo: {}
		},
		mounted() {
			let that = this
			this.getPosDetail(that.position)
		},
		methods: {
			getPosDetail(res) {
				let that = this
				that.robotId = res.robotId
				positonInfo({
					robotId: res.robotId,
					userId: getItem('userInfo').staffId
				}).then(res => {
					that.mapUrl = res.data.address
					that.mFloorEntity = res.data
					let vDom = that.$refs.circle_bottom
					let mapImgDom = document.getElementsByClassName('mapClass_ul')[0]

					let vDomZoomW = document.documentElement.clientWidth * 0.6
					let vDomZoomH = document.documentElement.scrollHeight * 0.8

					mapImgDom.style.width = res.data.width + 'px'
					mapImgDom.style.height = res.data.height + 'px'

					mapImgDom.style.margin = "0 auto"
					if (Number(res.data.width) > Number(res.data.height)) {
						mapImgDom.style.zoom = vDomZoomW / Number(res.data.width)
					} else {
						mapImgDom.style.zoom = vDomZoomH / Number(res.data.height)
					}

					that.$refs.legend.style.zoom = 1 / (vDomZoomH / Number(res.data.height))

					if (Number(res.data.width) <= 900) {
						vDom.style.width = '20px'
						vDom.style.height = '20px'
					} else if (Number(res.data.width) <= 1400 && Number(res.data.width) > 900) {
						vDom.style.width = '30px'
						vDom.style.height = '30px'
					} else if (Number(res.data.width) <= 1900 && Number(res.data.width) > 1400) {
						vDom.style.width = '45px'
						vDom.style.height = '45px'
					} else if (Number(res.data.width) > 1900) {
						vDom.style.width = '50px'
						vDom.style.height = '50px'
					}

				})
			},
			imgSuccess() {
				let that = this
				that.robotRouteByRobotId(that.position.number)
				that.ifDraw = true
			},
			robotRouteByRobotId(id) {
				let that = this
				getMapAndRouteByNumber({
					number: id
				}).then(res => {
					if (res.data && res.data.coord) {
						let drawAry = res.data.obstacles;
						drawAry.forEach(vu => {
							vu.drawList = []
							if (res.data.coord.split(";").findIndex(vi => vi == vu.point) == -1) {
								const cooList = res.data.coord.split(";");
								for (let x = 0; x < cooList.length; x++) {
									if (Math.sqrt((Math.pow(cooList[x].split(",")[0] - vu.point.split(",")[0], 2) + Math.pow(cooList[x].split(",")[1] - vu.point.split(",")[1], 2))) <= 5) {
										vu.index = x
										return false;
									}
								}
							} else {
								vu.index = res.data.coord.split(";").findIndex(vi => vi == vu.point)
							}
						})

						if (drawAry.length > 0 && drawAry[0].index > 0) {
							drawAry.unshift({
								dir: '-1',
								id: -1,
								index: 0
							})
						}

						let drawList = []
						res.data.coord.split(";").map(v => {
							drawList.push({
								x: Number(v.split(",")[0]),
								y: Number(v.split(",")[1])
							})
						})
						that.drawLine(drawList, drawAry)
					}
				})
			},
			drawLine(drawList, drawAry) {
				let that = this
				let dr_Len = drawList.length;
				if (dr_Len > 1) {
					for (var i = 0; i < drawList.length; i++) {
						if (i < drawList.length - 1) {
							let cWidth = that.calculationWidth({
								x1: drawList[i].x,
								y1: drawList[i].y,
								x2: drawList[i + 1].x,
								y2: drawList[i + 1].y
							})
							let cRotate = that.calculationRotate({
								x1: drawList[i].x,
								y1: drawList[i].y,
								x2: drawList[i + 1].x,
								y2: drawList[i + 1].y
							})
							if (drawAry.length > 0) {
								drawAry.forEach((resdr, resIndex) => {
									if (resIndex < drawAry.length-1) {
										if (i >= resdr.index && i < drawAry[resIndex+1].index) {
											that.lineList.push({
												dir: resdr.dir,
												lineColor: resdr.dir == '-1' ? '#FC2020' : (resdr.dir == '1' ? '#FFA749' : (resdr.dir == '2' ? '#8F4BFF' : (resdr.dir == '3' ? '#00EF20' : '#FC2020'))),
												width: cWidth,
												rotate: cRotate - 180,
												top: drawList[i].y,
												left: drawList[i].x
											})
										}
									} else if (resIndex == drawAry.length-1) {
										if (i >= resdr.index) {
											that.lineList.push({
												dir: resdr.dir,
												lineColor: resdr.dir == '-1' ? '#FC2020' : (resdr.dir == '1' ? '#FFA749' : (resdr.dir == '2' ? '#8F4BFF' : (resdr.dir == '3' ? '#00EF20' : '#FC2020'))),
												width: cWidth,
												rotate: cRotate - 180,
												top: drawList[i].y,
												left: drawList[i].x
											})
										}
									}
								})
							} else {
								that.lineList.push({
									dir: '',
									lineColor: '#FC2020',
									width: cWidth,
									rotate: cRotate - 180,
									top: drawList[i].y,
									left: drawList[i].x
								})
							}
						}
					}
				}
			},
			closeMap() {
				this.$emit('closeRobot', true)
			},
			// 计算长度
			calculationWidth(xy) {
				return Math.sqrt((xy.x2 - xy.x1) * (xy.x2 - xy.x1) + (xy.y2 - xy.y1) * (xy.y2 - xy.y1));
			},
			// 计算角度
			calculationRotate(xy) {
				let radian = Math.atan2(xy.y1 - xy.y2, xy.x1 - xy.x2);
				let angle = 180 / Math.PI * radian;
				return angle;
			},
			drawPointFun (rowInfo) {
				let mFloorEntity = this.mFloorEntity
				const mapX = Math.sqrt(Math.pow(rowInfo.x, 2));
				const mapOX = Math.sqrt(Math.pow(mFloorEntity.originX, 2));
				let ax = 0;
				if (rowInfo.x == 0) {
					ax = mapOX;
				} else if (rowInfo.x > 0) {
					ax = mapOX + mapX;
				} else if (rowInfo.x < 0) {
					ax = mapOX - mapX;
				}

				const mapH =  mFloorEntity.height * mFloorEntity.resolution;
				const mapY =  Math.sqrt(Math.pow(rowInfo.y, 2));
				const mapOy = Math.sqrt(Math.pow(mFloorEntity.originY, 2));
				let ay = 0;
				if (rowInfo.y == 0) {
					ay = mapY;
				} else if (rowInfo.y > 0) {
					ay = mapH - mapOy - mapY;
				} else if (rowInfo.y < 0) {
					ay = mapH - mapOy + mapY;
				}

				ax = Number(ax / mFloorEntity.resolution);
				ay = Number(ay / mFloorEntity.resolution);
				return [ax, ay]
			}
		},
		destroyed() {
			// 关闭
		},
		watch: {
			posInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					that.$nextTick(() => {
						if (newValue.positon && that.robotId == newValue.robotId) {
							if (that.position.robotType == '09' || that.position.robotType == '08') {
								that.$refs.circle_bottom.style.left = that.drawPointFun({
								x: Number(newValue.positon.split(',')[0]),
								y: Number(newValue.positon.split(',')[1])
							})[0] - 10 - Number(that.$refs.circle_bottom.style.width.substring(0, 2)) / 2 + 'px'
								that.$refs.circle_bottom.style.top = that.drawPointFun({
								x: Number(newValue.positon.split(',')[0]),
								y: Number(newValue.positon.split(',')[1])
							})[1] - 10 - Number(that.$refs.circle_bottom.style.width.substring(0, 2)) / 2 + 'px'
							} else {
								that.$refs.circle_bottom.style.left = Number(newValue.positon.split(',')[0]) - Number(that.$refs.circle_bottom.style.width.substring(0, 2)) / 2 + 'px'
								that.$refs.circle_bottom.style.top = Number(newValue.positon.split(',')[1]) - Number(that.$refs.circle_bottom.style.width.substring(0, 2)) / 2 + 'px'
							}
							that.$refs.circle_id.style.opacity = '1'
						}
					})
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@keyframes icon {
		0% {
			transform: translate(0, 0)
		}

		50% {
			transform: translate(0px, -10px)
		}

		100% {
			transform: translate(0, 0)
		}
	}

	.legend {
		position: absolute;
		left: 0px;
		bottom: 0px;
		width: 105px;
		z-index: 99;
		font-size: 12px;
	}

	.legend-li {
		width: 40px;
		height: 6px;
	}

	.legend-ui {
		display: flex;
		justify-content:space-between;
		align-items: center;
		margin: 2px 0px 2px 6px;
	}

	.pointClass {
		width: 3px;
		height: 3px;
		background-color: black;
		border-radius: 50%;
		position: absolute;
	}

	.linesClass {
		position: absolute;
		height: 6px;
		// border-top: 2px solid red;
	}

	.mapClass_ul {
		position: relative;
		top: 50vh;
	}

	.mapImg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}

	.mapClose {
		position: absolute;
		width: 30px;
		height: 30px;
		top: -15px;
		right: -15px;
		cursor: pointer;
	}

	.mapPostion {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		opacity: 0;

		.circle_bottom {
			background: #FF0000; 
			border-radius: 100%;
			width: 80px; 
			height: 80px; 
			filter: alpha(opacity=40);
			z-index: -100;
			box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.7);
			opacity: 0;
			position: absolute;
		}

		.animation {
			-webkit-animation: twinkling 2.1s infinite ease-in-out;
			animation: twinkling 2.1s infinite ease-in-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		.animation2 {
			-webkit-animation: twinkling 2.1s infinite ease-in-out;
			animation: twinkling 2.1s infinite ease-in-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		@-webkit-keyframes twinkling {
			0% {
				opacity: 0.8;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #FF0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}

			50% {
				opacity: 1;
				filter: alpha(opacity=50);
				-webkit-transform: scale(1.2); /* 保持1.2倍缩放 */
				background-color: #FF4444;
				box-shadow: 0px 0px 60px 30px rgba(255, 0, 0, 0.9); /* 阴影增大2倍 */
			}

			100% {
				opacity: 0.6;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #CC0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}
		}

		@keyframes twinkling {
			0% {
				opacity: 0.8;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #FF0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}

			50% {
				opacity: 1;
				filter: alpha(opacity=50);
				-webkit-transform: scale(1.2); /* 保持1.2倍缩放 */
				background-color: #FF4444;
				box-shadow: 0px 0px 60px 30px rgba(255, 0, 0, 0.9); /* 阴影增大2倍 */
			}

			100% {
				opacity: 0.6;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #CC0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/RobotMap.vue